import { createContext, useContext } from "react";

/** Lets a menu item close the menu it lives in after a selection. */
export const MenuContext = createContext<{ close: () => void } | null>(null);

export function useMenuClose(): () => void {
  return useContext(MenuContext)?.close ?? (() => undefined);
}
